import { pxToRem, theme } from '@pocketlaw/tetris';
import styled, { createGlobalStyle, css } from 'styled-components';
import 'shared/domains/pleditor@next/styles';
import { attachmentStyles } from './plugins/Attachments/styled';
import { assistantHighlightStyles } from './styles/assistantStyles';
import { balloonToolbarStyles } from './styles/balloonToolbarStyles';
import { commentsArchiveStyles } from './styles/commentsArchiveStyles';
import { dropdownStyles } from './styles/dropdownStyles';
import { highlightStyles } from './styles/highlightStyles';
import { appMentionBadgeThemeStyles, externalMentionBadgeThemeStyles, mentionStyles } from './styles/mentions';
import { editorSidebarStyles } from './styles/sidebar';
import { suggestionStyles } from './styles/suggestionStyles';
import { themeStyles } from './styles/theme';
import { toolbarStyles } from './styles/toolbar';
import { userAvatar } from './styles/userAvatar';
import { DocumentPageContainer } from '../../styled';
const LOGO_RATIO_HEIGHT = 9;
const LOGO_SIZE = 1.4; // Adjust to match DOCX/PDF logo size (visual comparison)
export const PleditorWrapper = styled(DocumentPageContainer) `
  margin-bottom: 0;
  line-height: 1.5;
`;
export const PleditorToolbarContainer = styled.div `
  z-index: 1;
  position: sticky;
  top: 0;
  margin: ${(props) => (props.$noMargin ? '0' : `0 ${theme.spacing.xl}`)};

  ${toolbarStyles}
`;
PleditorToolbarContainer.defaultProps = {
    id: 'pleditor-toolbar',
};
export const PleditorContainer = styled.div `
  z-index: 0;
  width: auto;
  display: flex;
  flex: 1;
  justify-content: center;
  gap: ${theme.spacing.lg};

  .ck.ck-content.ck-editor__editable:not(.ck-comment__input .ck.ck-content.ck-editor__editable) {
    flex: 1;
    max-width: ${pxToRem(800)};
    padding: ${theme.spacing['2xl']};
    background-color: ${theme.semantic.surface.primary};

    ${({ $companyLogoUrl }) => $companyLogoUrl &&
    css `
        --logo-height: ${LOGO_RATIO_HEIGHT * LOGO_SIZE}mm;

        padding-top: calc(${theme.spacing['2xl']} + ${theme.spacing['2xl']} + var(--logo-height));
        background-image: url(${$companyLogoUrl});
        background-position-y: ${theme.spacing['2xl']};
        background-position-x: ${theme.spacing['2xl']};
        background-size: auto var(--logo-height);
        background-repeat: no-repeat;
      `}

    &:not(.ck-editor__nested-editable).ck-rounded-corners {
      border-radius: ${theme.borderRadius.lg};

      &.ck-focused {
        box-shadow: none;
        border: ${(props) => props.$isDocumentPreview
    ? `solid ${pxToRem(1)} transparent`
    : `solid ${pxToRem(1)} ${theme.semantic.border.default}`};
      }
    }
  }
`;
export const PleditorSidebar = styled.div `
  width: 25%;
  transition: all 225ms ease-in-out;

  ${editorSidebarStyles}
  ${suggestionStyles}
`;
export const ExternalPleditorStyles = createGlobalStyle `
  ${externalMentionBadgeThemeStyles};
`;
export const AppPleditorStyles = createGlobalStyle `
  ${appMentionBadgeThemeStyles};
`;
export const BasePleditorStyles = createGlobalStyle `
  .ck {
    ${themeStyles};
  }
  
  ${mentionStyles};
  ${userAvatar};
  ${balloonToolbarStyles};
  ${assistantHighlightStyles};
  ${dropdownStyles};
  ${commentsArchiveStyles};
  ${attachmentStyles};
  ${highlightStyles};
`;
